import api from "@/api"
import baseURL from "@/service/api"
import { getAuthHeader } from "@/util"

const state = {
  orderList: [],
  insufficientPayment: [],
  insufficientPaymentDetail: {},
  orderDetail: {}
}
const actions = {
  getOrders({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.orders(params).then(
        (response) => {
          commit("setOrders", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  cancelOrder({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.cancelOrder(orderId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  retryShipment({ _ }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.retryShipment(orderId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getInsufficientPayment({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.order.insufficientPayment(params).then(
        (response) => {
          commit("setInsufficientPayment", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getInsufficientPaymentDetail({ commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.insufficientPaymentDetail(orderId).then(
        (response) => {
          commit("setInsufficientPaymentDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  paymentConfirm({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.paymentConfirm(orderId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  getOrderDetail({ commit }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.orderDetail(orderId).then(
        (response) => {
          commit("setOrderDetail", response.data.data)
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  processOrder({ _ }, { orderId }) {
    return new Promise((resolve, reject) => {
      api.order.processOrder(orderId).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  rejectOrder({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.rejectOrder(orderId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  updateShipmentStatus({ _ }, { orderId, payloads }) {
    return new Promise((resolve, reject) => {
      api.order.updateShipmentStatus(orderId, payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  exportOrders({ _ }, { params }) {
    return new Promise((resolve, reject) => {
      baseURL.get('/orders/export', {
        params: params,
        responseType: 'blob',
        headers: getAuthHeader()
      }).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setOrders(state, value) {
    state.orderList = value
  },
  setOrderDetail(state, value) {
    state.orderDetail = value
  },
  setInsufficientPayment(state, value) {
    state.insufficientPayment = value
  },
  setInsufficientPaymentDetail(state, value) {
    state.insufficientPaymentDetail = value
  }
}
const getters = {
  orderList: (state) => state.orderList,
  orderDetail: (state) => state.orderDetail,
  insufficientPayment: (state) => state.insufficientPayment,
  insufficientPaymentDetail: (state) => state.insufficientPaymentDetail
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
